module.exports = __webpack_public_path__ + "static/image/history/pc/202210@3x.jpg?7473f219";